export const degreeOptions = [
  "High School",
  "Associate",
  "Bachelor",
  "Master",
  "Doctorate",
];

export const languagesList = [
  "English",
  "French",
  "German",
  "Spanish",
  "Italian",
  "Polish",
  "Romanian",
  "Dutch",
  "Portuguese",
  "Greek",
  "Hungarian",
  "Czech",
  "Bulgarian",
  "Swedish",
  "Danish",
  "Finnish",
  "Norwegian",
  "Slovak",
  "Serbian",
  "Croatian",
  "Slovenian",
  "Bosnian",
  "Albanian",
  "Macedonian",
  "Montenegrin",
  "Turkish",
  "Russian",
  "Ukrainian",
];
